import { Controller } from "@hotwired/stimulus"

// A /search landing page row (providers/landing/_rows): Previous/Next scroll its cards
// by about a viewport of cards and are disabled at either end. The scroller arrives
// later, in the row's lazy Turbo Frame, so the buttons stay disabled until it does.
export default class extends Controller {
  static targets = ["scroller", "previous", "next"]

  scrollerTargetConnected() {
    this.update()
  }

  scrollerTargetDisconnected() {
    this.update()
  }

  previous() {
    this.scrollBy(-1)
  }

  next() {
    this.scrollBy(1)
  }

  // A frame in the row that came back as an error (rate limited, signed out, a failure) never shows
  // Turbo's "Content missing": the row's own frame hides the row, as an empty one is hidden; a card's
  // photo or the row's open times just stay as they were.
  hide(event) {
    event.preventDefault()
    if (event.target.id.startsWith("landing-topic-") || event.target.id === "landing-preferred") this.element.hidden = true
  }

  update() {
    const scroller = this.hasScrollerTarget ? this.scrollerTarget : null
    const max = scroller ? scroller.scrollWidth - scroller.clientWidth : 0
    const position = scroller ? scroller.scrollLeft : 0
    if (this.hasPreviousTarget) this.previousTarget.disabled = !scroller || position <= 2
    if (this.hasNextTarget) this.nextTarget.disabled = !scroller || position >= max - 2
  }

  scrollBy(direction) {
    if (!this.hasScrollerTarget) return

    const scroller = this.scrollerTarget
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    scroller.scrollBy({ left: direction * scroller.clientWidth * 0.85, behavior: reduceMotion ? "auto" : "smooth" })
  }
}
